module.exports = __webpack_public_path__ + "static/media/developers_overview_3.35d900a2.png";